// A BLS tenant owns its market, so the feed should never sit on an empty one
// for long: this decides whether it's time to seed the tenant's default back
// in. It says no while the agent is mid-edit (the mobile picker is open, or
// they just cleared the last market from it) - that's a state they put
// themselves in on the way to choosing a replacement, not one to auto-correct.
export const shouldReseedDefaultMarket = ({
  mlsRestricted,
  user,
  userLocation,
  marketPickerOpen,
  marketClearedByUser,
  defaultMarket,
}) => {
  if (!mlsRestricted || !user) return false;
  if (userLocation) return false;
  if (marketPickerOpen || marketClearedByUser) return false;
  if (!defaultMarket?.city || !defaultMarket?.state) return false;
  return true;
};
